/// <reference types="vite-plugin-svgr/client" />
import { FunctionComponent, SVGProps } from 'react'

// TODO : FIX HOW TO MAKE DYNAMIC BASED ON PRODUCT_KEY VITE ENV?
/* eslint-disable import/no-extraneous-dependencies */
import CampaiBrandIcon from '@/assets/public/brand/campai/icon.svg?react'
import CampaiBrandLogo from '@/assets/public/brand/campai/logo.svg?react'
import CampaiBrandIconRaw from '@/assets/public/brand/campai/icon.svg?raw'
import CampaiBrandLogoRaw from '@/assets/public/brand/campai/logo.svg?raw'
import DefaultBrandConnectIcon from '@/assets/public/brand/campai/connect-icon.svg?react'
import DefaultBrandConnectSimpleIcon from '@/assets/public/brand/campai/connect-simple-icon.svg?react'
import WunderPassBrandIcon from '@/assets/public/brand/wunderpass/icon.svg?react'
import WunderPassBrandLogo from '@/assets/public/brand/wunderpass/logo.svg?react'
import WunderPassBrandIconRaw from '@/assets/public/brand/wunderpass/icon.svg?raw'
import WunderPassBrandLogoRaw from '@/assets/public/brand/wunderpass/logo.svg?raw'
import AlternateBrandConnectIcon from '@/assets/public/brand/wunderpass/connect-icon.svg?react'
import AlternateBrandConnectSimpleIcon from '@/assets/public/brand/wunderpass/connect-simple-icon.svg?react'
/* eslint-enable import/no-extraneous-dependencies */
import { env } from '@/env'

let BrandIcon: FunctionComponent<SVGProps<SVGSVGElement>> = CampaiBrandIcon
let BrandLogo: FunctionComponent<SVGProps<SVGSVGElement>> = CampaiBrandLogo
let BrandIconRaw: string = CampaiBrandIconRaw
let BrandLogoRaw: string = CampaiBrandLogoRaw
let BrandConnectIcon: FunctionComponent<SVGProps<SVGSVGElement>> = DefaultBrandConnectIcon
let BrandConnectSimpleIcon: FunctionComponent<SVGProps<SVGSVGElement>> = DefaultBrandConnectSimpleIcon

if (env.VITE_PRODUCT_KEY === 'wunderpass') {
    BrandIcon = WunderPassBrandIcon
    BrandLogo = WunderPassBrandLogo
    BrandIconRaw = WunderPassBrandIconRaw
    BrandLogoRaw = WunderPassBrandLogoRaw
    BrandConnectIcon = AlternateBrandConnectIcon
    BrandConnectSimpleIcon = AlternateBrandConnectSimpleIcon
}

export { BrandConnectIcon, BrandConnectSimpleIcon, BrandIcon, BrandLogo, BrandIconRaw, BrandLogoRaw }
